import CommentFA from './fa/fa.json'

const CommentMessages = {
  fa: { ...CommentFA },
}

export default CommentMessages
